import { createAction, props } from '@ngrx/store';

import { ConnectorListEntity } from '../components/connector-list/connector-list.entity';

export enum ConnectorActions {
	InitConnectorList = '[Connector] get connector list',
	RefreshConnectorList = '[BE][Connector] refresh Connector list',
	FetchConnectorListFail = '[BE][Connector] fetch Connector list fail',
	FetchConnectorListSuccess = '[BE][Connector] fetch Connector list success',
	NavigateToConnectorRoute = '[Connector] navigate to Connector route',
	NavigateToConnectorCreateRoute = '[Connector] navigate to Connector create route',
	NavigateToConnectorDuplicateRoute = '[Connector] navigate to Connector duplicate route',
	NavigateToDepotFromConnectorRoute = '[Connector] navigate to depot with connector route',
	DeleteConnector = '[Connector] delete connector',
	BulkDeleteConnectors = '[Connector] delete many connectors',
	DeleteConnectorSuccess = '[BE][Connector] delete connector success',
	DeleteConnectorFail = '[BE][Connector] delete connector fail',
	BulkDeleteConnectorsSuccess = '[BE][Connector] delete many connectors success',
	BulkDeleteConnectorsFail = '[BE][Connector] delete many connectors fail',
	ToggleConnectorStatus = '[BE][Connector] toggle connector status',
}

export const initConnectorList = createAction(
	ConnectorActions.InitConnectorList
);

export const refreshConnectorList = createAction(
	ConnectorActions.RefreshConnectorList
);

export const fetchConnectorListSuccess = createAction(
	ConnectorActions.FetchConnectorListSuccess,
	props<{ connectorList: ConnectorListEntity }>()
);

export const fetchConnectorListFail = createAction(
	ConnectorActions.FetchConnectorListFail,
	props<{ error: unknown }>()
);
export const navigateToConnector = createAction(
	ConnectorActions.NavigateToConnectorRoute,
	props<{
		id: number;
		connectorType: string;
	}>()
);
export const navigateToConnectorCreate = createAction(
	ConnectorActions.NavigateToConnectorCreateRoute
);
export const navigateToConnectorDuplicate = createAction(
	ConnectorActions.NavigateToConnectorDuplicateRoute,
	props<{ id: number; connectorType: string }>()
);

export const navigateToDepotFromConnector = createAction(
	ConnectorActions.NavigateToDepotFromConnectorRoute,
	props<{ id: number }>()
);

export const deleteConnector = createAction(
	ConnectorActions.DeleteConnector,
	props<{ connectorId: number }>()
);

export const bulkDeleteConnectors = createAction(
	ConnectorActions.BulkDeleteConnectors,
	props<{ connectorIds: Array<number> }>()
);

export const deleteConnectorSuccess = createAction(
	ConnectorActions.DeleteConnectorSuccess
);

export const deleteConnectorFail = createAction(
	ConnectorActions.DeleteConnectorFail
);

export const bulkDeleteConnectorsSuccess = createAction(
	ConnectorActions.BulkDeleteConnectorsSuccess
);

export const bulkDeleteConnectorsFail = createAction(
	ConnectorActions.BulkDeleteConnectorsFail
);

export const toggleConnectorStatus = createAction(
	ConnectorActions.ToggleConnectorStatus,
	props<{ connectorId: number; connectorType: string }>()
);
